import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
// removed legacy rxjs-compat operator import
import {PaginationInstance} from "ngx-pagination";
import {UserVerificationService} from "../services/user-verification.service";
import {KeycloakService} from "../services/keycloak.service";
import {ApiEndpoints} from "../services/api-endpoints";

import {StringUtils} from "../services/string-utils";
declare var $: any;

@Component({ standalone: false, 
  selector: 'app-get-all-network-server-groups',
  templateUrl: './get-all-network-server-groups.component.html',
})
export class GetAllNetworkServerGroupsComponent implements OnInit, OnDestroy {

  private apiUrl = ApiEndpoints.GET_ALL_NETWORK_SERVER_GROUPS;
  private userUrl = ApiEndpoints.GET_USER;

  isAdmin: boolean = false;
  username: string = KeycloakService.username;
  list: any[];
  p: number = 1;
  filterSearch: any;
  keywordSearch: any;
  ownerId;

  public ownerFname;
  public ownerLname;
  public ownerEmail;
  public ownerUname;
  public ownerAffiliation;

  public visible = false;
  public visibleAnimate = false;

  public show(): void {
    this.visible = true;
    setTimeout(() => this.visibleAnimate = true, 100);
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      this.hide();
    }
  }

  configPagerGetAllNetworkServerGroups: PaginationInstance = {
    id: 'network-server-groups-list',
    currentPage: 1,
    itemsPerPage: 10,
  };

  constructor(private route: ActivatedRoute,
              private http: HttpClient,
              private router: Router,
              private userVerificationService: UserVerificationService) {
    this.route.params.subscribe(params => {
      this.filterSearch = params['filterSearch'];
      this.keywordSearch = params['keywordSearch'];
      if (this.filterSearch != "Search Type" || this.keywordSearch != null) {
        this.displayHeaderSearch(this.filterSearch, this.keywordSearch);
      }
    });

    this.isAdmin = this.userVerificationService.isAdmin;
    this.getServers();
    this.getData();
    this.displayHeaderSearch(this.filterSearch, this.keywordSearch);
    this.displayHeaderSearch(this.filterSearch, this.keywordSearch);
    this.displayHeaderSearch(this.filterSearch, this.keywordSearch);
  }

  getData() {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    let options =  {headers: headers};
    var body: any = {"username": this.username};
    return this.http.post<any>(this.apiUrl, body, options)
  }

  getServers() {
    this.getData().subscribe(list => {
      this.list = this.parseNetworkServerGroupsList(list);
      this.setActive(this.list);
    })
  }

  parseNetworkServerGroupsList(list) {
    list.forEach(list => {
      list.netIds = StringUtils.insertSpacesBetweenIds(list.netIds);
     });
    return list;
  }

  getUserDetails(item) {
    this.ownerUname = "";
    this.ownerFname = "";
    this.ownerLname = "";
    this.ownerEmail = "";
    this.ownerAffiliation = "";

    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    let options =  {headers: headers};
    var body: any = {
      "username": item
    };
    this.http.post<any>(this.userUrl, body, options).subscribe(
        data => {
          this.ownerUname = data.username;
          this.ownerFname = data.firstName;
          this.ownerLname = data.lastName;
          this.ownerEmail = data.email;
          this.ownerAffiliation = data.affiliation;
        }
      );
  }

  displayHeaderSearch(filterSearch, keywordSearch) {
    if (filterSearch != "Search Type" && keywordSearch != "" && filterSearch && keywordSearch) {
      var url = ApiEndpoints.GET_ALL_NETWORK_SERVER_GROUPS;
      if (filterSearch == "netId") {
        var body: any = {
          "username": this.username,
          "netId": keywordSearch
        };
      }
      if (filterSearch == "nsId") {
        var body: any = {
          "username": this.username,
          "nsId": keywordSearch
        };
      }
      if (filterSearch == "name") {
        var body: any = {
          "username": this.username,
          "name": keywordSearch
        };
      }
      const headers = new HttpHeaders({'Content-Type': 'application/json'});
      let options =  {headers: headers};
      this.http.post(url, body, options).subscribe(
          data => {
            this.list = this.parseNetworkServerGroupsList(data)
          }
      );
    }
    if (filterSearch != "Search Type" && keywordSearch == "") {
      this.router.navigate(['/all-network-groups']);
    }
  }

  setActive(list){
    var totalStatus = list.length;
    var totalActive = 0;
    var totalError = 0;
    for(let item of list){
      if (item.status == "Active") {
        totalActive = totalActive + 1;
      } else {
        totalError = totalError + 1;
      }
    }
    $(".table-filter-search option").eq(0).html("All (" + totalStatus + ")");
    $(".table-filter-search option").eq(1).html("Active (" + totalActive + "/" + totalStatus + ")");
    $(".table-filter-search option").eq(2).html("Disconnected (" + totalError + "/" + totalStatus + ")");

    $('.table-filter-search').selectpicker({
      liveSearch: true,
      maxOptions: 1
    });
  }

  ngOnInit() {
    $(document).on("click", ".table-filter-search  .dropdown-menu .dropdown-item", function () {
      var index = $(this).attr("data-original-index");
      if (index == 0) {
        $("#network-server-groups-list tbody tr").each(function () {
          $(this).show();
        });
      }
      if (index == 1) {
        $("#network-server-groups-list tbody tr").each(function () {
          if ($(this).find("td").eq(2).html() == "Active") {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
      }
      if (index == 2) {
        $("#network-server-groups-list tbody tr").each(function () {
          if ($(this).find("td").eq(2).html() != "Active") {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
      }
    });
  }

  ngAfterViewInit() {
    $("#menu0").removeClass("collapse");
    $("#menu0").prev().removeClass("collapsed");
    $("#menu1").addClass("collapse");
    $("#menu1").prev().addClass("collapsed");
    $("#menu2").addClass("collapse");
    $("#menu2").prev().addClass("collapsed");
    $("#menu3").addClass("collapse");
    $("#menu3").prev().addClass("collapsed");
  }

  ngOnDestroy() {

  }

}
